import React, { useEffect, useRef, useState } from 'react'
import { useStateValue } from '@State'
import { client } from '@Utils'
import { billingQueue as urls } from '@URLS'
import { toast } from '@CommonComponents/toast'
import { LoadingSpinner } from '@CommonComponents'
import { Pagination } from '@CommonComponents/buttons'
import { AssignedItem } from './AssignedItem'

const PAGE_SIZE = 20

export const AssignedTab = () => {
  const [state, dispatch] = useStateValue()
  const { assigned, assignedMeta, schools } = state
  const [loading, setLoading] = useState(false)
  const [search, setSearch] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const searchTimer = useRef(null)

  const fetchAssigned = async (searchVal) => {
    setLoading(true)
    try {
      const resp = await client.get(urls.getAssigned({ search: searchVal || undefined }))
      dispatch({
        type: 'SET_ASSIGNED',
        payload: {
          items: resp.data.items,
          total: resp.data.total,
          awaiting_payment: resp.data.awaiting_payment,
        },
      })
    } catch {
      toast.error('Failed to load assigned courses.')
    }
    setLoading(false)
  }

  const fetchSchools = async () => {
    if (schools.length > 0) return
    try {
      const resp = await client.get(urls.getSchools())
      dispatch({ type: 'SET_SCHOOLS', payload: resp.data.schools })
    } catch {
      // non-critical
    }
  }

  useEffect(() => {
    fetchSchools()
    fetchAssigned()
  }, [])

  const handleSearchChange = e => {
    const val = e.target.value
    setSearch(val)
    setCurrentPage(1)
    clearTimeout(searchTimer.current)
    searchTimer.current = setTimeout(() => fetchAssigned(val), 300)
  }

  return (
    <div>
      <div className="mb-3">
        {assignedMeta.awaiting_payment > 0 && (
          <p className="text-muted small mb-2">
            <span className="text-warning">
              {assignedMeta.awaiting_payment} one-time invoice{assignedMeta.awaiting_payment !== 1 ? 's' : ''} awaiting payment
            </span>
          </p>
        )}
        <div className="input-group input-group-sm" style={{ maxWidth: '280px' }}>
          <input
            type="text"
            className="form-control"
            placeholder="Search by title or course #"
            value={search}
            onChange={handleSearchChange}
          />
        </div>
      </div>

      {loading ? (
        <div className="text-center py-5">
          <LoadingSpinner />
        </div>
      ) : assigned.length === 0 ? (
        <div className="card-myed">
          <div className="card-body text-center py-5">
            <i className="fa-regular fa-clipboard-check fa-2x text-muted mb-3" />
            <h5 className="text-muted">No assigned courses</h5>
            <p className="text-muted small mb-0">
              {search
                ? `No results for "${search}".`
                : 'Courses confirmed in the billing queue will appear here.'}
            </p>
          </div>
        </div>
      ) : (
        <div>
          {assigned.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE).map(br => (
            <AssignedItem key={br.id} br={br} />
          ))}
          {Math.ceil(assigned.length / PAGE_SIZE) > 1 && (
            <Pagination
              currentPage={currentPage}
              rate={PAGE_SIZE}
              total={assigned.length}
              setCurrentPage={setCurrentPage}
            />
          )}
        </div>
      )}
    </div>
  )
}
